export function randomNumber(min, max) {
  if (typeof min !== "number" || typeof max !== "number") {
    throw new Error("Both min and max must be numbers");
  }
  if (min > max) {
    throw new Error(
      "The min value must be less than or equal to the max value"
    );
  }

  return Math.random() * (max - min) + min;
}
